module.exports = __webpack_public_path__ + "img/responsive hospitium-10.0505294d.jpg";